import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

export async function streamWrite(body, onText, path = "/admin/ai/write") {
  const res = await fetch(`${API}${path}`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "ChatGPT ist gerade nicht erreichbar");
  const reader = res.body.getReader(), dec = new TextDecoder();
  let buf = "", full = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n"); buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.t) { full += ev.t; onText(full); }
    }
  }
  return full;
}

const split = (full) => {
  const [title, ...rest] = full.replace(/\*\*/g, "").split("\n");
  return { title: title.trim(), body: rest.join("\n").trim() };
};

export function AiWriter({ kind, onWrite, testId }) {
  const [idea, setIdea] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await streamWrite({ kind, idea }, (full) => onWrite(split(full))); toast.success("Text von ChatGPT eingefügt – du kannst ihn noch anpassen"); }
    catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-100 p-3 space-y-2" data-testid={testId}>
      <p className="text-xs font-bold text-emerald-800 flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5" /> Mit ChatGPT schreiben lassen</p>
      <div className="flex gap-2">
        <input value={idea} onChange={(e) => setIdea(e.target.value)} maxLength={500} placeholder="Worum geht's? z. B. Neue Prämie im Shop: Kopfhörer"
          data-testid={`${testId}-idea`} className="flex-1 min-w-0 h-10 px-3 rounded-xl border border-emerald-200 bg-white text-sm outline-none focus:ring-2 focus:ring-emerald-300" />
        <button type="button" onClick={go} disabled={busy || idea.trim().length < 3} data-testid={`${testId}-btn`}
          className="shrink-0 h-10 px-4 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold flex items-center gap-1.5 disabled:opacity-50 transition-colors">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Schreiben
        </button>
      </div>
    </div>
  );
}
